"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Created by sguilly on 05/10/16.
 */
/**
 * Created by sguilly on 23/08/16.
 */
(function () {
  "use strict";

  angular.module("login").run(["$rootScope", "$window", "$state", "authEvents", "AuthService", "CustomersService", "UsersService", "ModalService", function ($rootScope, $window, $state, authEvents, AuthService, CustomersService, UsersService, ModalService) {
    var _this = this;

    var log = debug("login:run");

    log("run pages");

    $rootScope.nbTableLines = 10;

    $rootScope.logout = function () {
      log("logout");

      AuthService.logout();
    };

    $rootScope.openTutorial = function () {
      ModalService.openComponent("tutorial-modal", {
        size: "lg"
      }).then(function () {
        console.log("close modal");
      }).catch(function (err) {
        console.error("err", err);
      });
    };

    $rootScope.$bus.subscribe({
      channel: "login",
      topic: "success",
      callback: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var url, urlStorage;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  url = window.location;
                  _context.next = 3;
                  return CustomersService.getById($rootScope.$user.customerId);

                case 3:
                  $rootScope.customer = _context.sent;

                  $rootScope.$user.customerName = $rootScope.customer.name;

                  log("url=", url);

                  urlStorage = localStorage.getItem("$location.url");


                  console.log("after login open :" + urlStorage);
                  $state.go(urlStorage ? urlStorage.replace("/", "") : "home");

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function callback() {
          return _ref.apply(this, arguments);
        };
      }()
    });

    $rootScope.$bus.subscribe({
      channel: "logout",
      topic: "success",
      callback: function callback() {
        $state.go("login");
      }
    });

    setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!$rootScope._cookieReady) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return $rootScope._cookieReady;

            case 3:
              AuthService.whoami();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    })), 200);
  }]);
})();